import {
  FontStyleOptions,
  TypographyStyleOptions,
} from '@material-ui/core/styles/createTypography'
import { createTheme } from '@material-ui/core/styles'
import createPalette from '@material-ui/core/styles/createPalette'

const palette = createPalette({
  background: {
    default: '#ffffff',
    paper: '#f6f7f9',
  },

  primary: {
    main: '#2e3943',
  },
})

const titleStyles: TypographyStyleOptions & FontStyleOptions = {
  fontFamily: 'SwecoSans, Mukta, sans-serif',
  fontWeight: 500,
  textTransform: 'uppercase',
}

export const theme = createTheme({
  palette,

  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1112,
      xl: 1920,
    },
  },

  typography: {
    fontFamily: 'Mukta, sans-serif',
    fontSize: 16,
    fontWeightLight: 400,
    fontWeightMedium: 400,
    fontWeightRegular: 400,
    fontWeightBold: 400,
    h1: {
      ...titleStyles,
      fontSize: '96px',
    },
    h2: {
      ...titleStyles,
      fontSize: '60px',
    },
    h3: {
      ...titleStyles,
      fontSize: '48px',
    },
    h4: {
      ...titleStyles,
      fontSize: '34px',
    },
    h5: {
      ...titleStyles,
      fontSize: '24px',
    },
    h6: {
      ...titleStyles,
      fontSize: '20px',
    },
    subtitle1: {
      ...titleStyles,
      fontSize: '16px',
    },
    subtitle2: {
      ...titleStyles,
      fontSize: '14px',
    },
    body1: {
      fontSize: '16px',
    },
    body2: {
      fontSize: '14px',
    },
    caption: {
      fontSize: '12px',
    },
    overline: {
      fontSize: '12px',
    },
  },

  props: {
    MuiTextField: {
      variant: 'outlined',
      fullWidth: true,
    },
    MuiSwitch: {
      color: 'primary',
    },
    MuiTabs: {
      indicatorColor: 'primary',
    },
  },

  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
      },
      text: {
        fontSize: '14px',
      },
      textSizeSmall: {
        fontSize: '14px',
      },
      textSizeLarge: {
        fontSize: '15px',
      },
    },
    MuiLink: {
      root: {
        fontSize: '16px',
      },
    },
    MuiTab: {
      root: {
        textTransform: 'none',
      },
    },
    MuiTable: {
      root: {
        breakInside: 'avoid',
      },
    },
    MuiTableCell: {
      root: {
        fontSize: '16px',
      },
      head: {
        ...titleStyles,
        fontWeight: 600,
        textTransform: 'none',
        background: palette.background.paper,
      },
    },
    MuiDialogTitle: {
      root: {
        ...titleStyles,
      },
    },
    MuiDialogActions: {
      spacing: {
        padding: 16,
      },
    },
  },

  shape: {
    borderRadius: 3,
  },
})
